import { render } from "./Personaldetail.vue?vue&type=template&id=7a3cfe01"
import script from "./Personaldetail.vue?vue&type=script&lang=js"
export * from "./Personaldetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__